module.exports = __webpack_public_path__ + "static/media/AGENCE-GARDEN DESIGN.10eec7f5.png";